import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveCustomForms,
  submitUpdateCustomForm,
  submitUpdateCustomFormsVisibility,
  submitUploadCustomForm
} from '~/api/data/forms/mutations';
import { loadCustomForm, loadCustomForms } from '~/api/data/forms/queries';
import { CustomFormEditPage, LibraryFormsPage } from '~/pages/library/custom-forms';

const customFormsLibraryChildren = [
  {
    path: 'archive',
    action: byMethod({ POST: submitArchiveCustomForms })
  },
  {
    path: 'visibility',
    action: byMethod({
      POST: submitUpdateCustomFormsVisibility
    })
  },
  {
    // Uploads POST here from the dialog on the parent list page.
    path: 'new',
    action: byMethod({
      POST: submitUploadCustomForm
    })
  },
  {
    path: ':id',
    loader: merge({ customForm: loadCustomForm }),
    action: byMethod({
      PUT: submitUpdateCustomForm
    }),
    element: <CustomFormEditPage />
  }
];

export const formsRoute: RouteObject = {
  path: 'forms',
  loader: merge({
    customForms: loadCustomForms
  }),
  element: <LibraryFormsPage />,
  children: customFormsLibraryChildren
};
